import { type APIDocument } from '@visorpro/client'
import _ from 'lodash'

const getModelIds = (document: APIDocument): string[] =>
    document.document_to_product_model?.map(
        (relation) => relation.product_model.id,
    ) ?? []

/**
 * Whether a metadata upload would change anything it writes to the document:
 * its title, type, or product models.
 */
export const hasDocumentChanges = (
    oldDocument: APIDocument,
    newDocument: APIDocument,
): boolean =>
    oldDocument.title !== newDocument.title ||
    oldDocument.type !== newDocument.type ||
    _.xor(getModelIds(oldDocument), getModelIds(newDocument)).length > 0
